import { AddIcon, ArrowDownIcon, ArrowUpDownIcon, ArrowUpIcon, WarningTwoIcon } from '@chakra-ui/icons'
import { Button, Card, CardBody, CardFooter, Flex, Grid, GridItem, Heading, IconButton, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Spinner, Table, TableContainer, Tag, TagLabel, TagLeftIcon, Tbody, Td, Text, Th, Thead, Tooltip, Tr, useDisclosure } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useDoorData } from './context/DoorContext'
import CreateEmployeeModal from './CreateEmployeeModal'

function AccessLogCard() {


  const { log, getDoorStatusBadge, getDoorName, userLog, pickedUserLog, loading, loadDataFromEmaitinimas } = useDoorData()
  const [clickedLogBox, setClickedLogBox] = useState(null);
  const [clickedLogCardNo, setClickedLogCardNo] = useState(null);
 
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { isOpen: isOpenUserLog, onOpen: onOpenUserLog, onClose: onCloseUserLog } = useDisclosure()

  return (
    <>
      <Grid mx={'5vw'} 
      // gridRow={'5'} 
      templateColumns={'repeat(auto-fill, minmax(160px,1fr))'} gap={6} autoColumns={'minmax(160px,1fr)'} sx={
        {
          '::-webkit-scrollbar': {
            width: '16px',
          },

          '::-webkit-scrollbar-track': {
            backgroundColor: '#e4e4e4',
            borderRadius: '2rem'
          },
          '::-webkit-scrollbar-thumb': {
            backgroundColor: '#cecece',
            borderRadius: '2rem'
          }
        }
      } overflowX={'scroll'} gridAutoFlow={'column'}>
        {log.map((logEntry, index) => {
           // jei ne emaitinimas sistema tada naudoti pname, psurname

           if(!loadDataFromEmaitinimas){
            logEntry.name = logEntry.pname;
            logEntry.surname = logEntry.psurname;
          }

          const date = new Date(logEntry.date).toLocaleString('lt-LT');
          const doorName = getDoorName(logEntry.door_id)

          const fullName = logEntry.name + ' ' + logEntry.surname
          const logAction = getDoorStatusBadge(logEntry.action);
          //console.log(logEntry);
          return (
     
            <GridItem cursor={'pointer'} key={index}>
              <Card minHeight={'10rem'} mb={'0.5rem'} border={`solid 1px ${logAction.bgColor}`}>
            {!loadDataFromEmaitinimas && logEntry.action === 'NOT_FOUND' && logEntry.pname === null && <IconButton size={'xs'} colorScheme={'green'} borderRadius={'0 0 1rem 0'} position={'absolute'} icon={<AddIcon />} onClick={() => {setClickedLogCardNo(logEntry.card_no);  onOpen();  }}/>}
                <CardBody  onClick={() => { userLog(logEntry.card_no); setClickedLogBox(logEntry.id); onOpenUserLog() }}>

                  <Tag size={'sm'} variant='outline' colorScheme={logAction.color}>
                    <TagLeftIcon as={logAction.icon} />
                    <TagLabel>{logAction.text}</TagLabel>
                  </Tag>
                  {logEntry.drunk > '0.000' && <Text fontSize={'md'} mb={'5px'} color={'red'} minHeight={'1rem'}><WarningTwoIcon/> {logEntry.drunk} <WarningTwoIcon/></Text>}
                  <Text fontSize={'xs'} mb={'5px'} color={'#a7a7a7'} minHeight={'1rem'}>{logEntry.groupname}</Text>
                  <Heading minHeight={'3rem'} size='sm'>{logEntry.direction !== '' ? logEntry.direction === 'INSIDE' ? <Tooltip hasArrow label='Vidinės durys' fontSize='md'><ArrowUpIcon ml={'-1rem'} color={logAction.color} /></Tooltip> : <Tooltip hasArrow label='Išorinės durys' fontSize='md'><ArrowDownIcon ml={'-1rem'} color={logAction.color} /></Tooltip> : <ArrowUpDownIcon ml={'-1rem'} color={logAction.color} />} {logEntry.name == null ? logEntry.card_no : fullName}</Heading>
                  <Text fontSize={'sm'} mt={'1rem'}>{logEntry.door_id === 0 ? 'Visos durys' : doorName}</Text>
                </CardBody>
                <CardFooter p={'0'} pb={'0.3rem'} justifyContent={'center'}><Text fontSize={'sm'} color={'gray'}>{date}</Text></CardFooter>
              </Card>
            </GridItem>

          )
        })}
      </Grid>

      <CreateEmployeeModal onlyCreate={true} onOpen={onOpen} isOpen={isOpen} onClose={onClose} editMode={false} 
        editEmployee={{name: '', surname: '', cardno: clickedLogCardNo, group: null }} setEditEmployee={[]} />

      <Modal isOpen={isOpenUserLog} size={'6xl'} onClose={onCloseUserLog}>
        <ModalOverlay />
        <ModalContent>

        {loadDataFromEmaitinimas ?
          <ModalHeader>{pickedUserLog[0]?.name !== null && `${pickedUserLog[0]?.name} ${pickedUserLog[0]?.surname} naujausi praėjimo įrašai`}</ModalHeader>
          :
          <ModalHeader>{pickedUserLog[0]?.pname !== null && `${pickedUserLog[0]?.pname} ${pickedUserLog[0]?.psurname} naujausi praėjimo įrašai`}</ModalHeader>
        }
          <ModalCloseButton />
          <ModalBody>
            {loading ?
              <Spinner
                thickness='4px'
                speed='0.65s'
                emptyColor='gray.200'
                color='green.500'
                size='xl'
              />
              :
              <TableContainer>
                <Table maxHeight={'60vh'} display={'block'} overflowY={'scroll'} variant='simple'>
                  <Thead>
                    <Tr>
                      <Th>ID</Th>
                      <Th>Vardas Pavardė</Th>
                      <Th>Kortelės Nr.</Th>
                      {!loadDataFromEmaitinimas && <Th>Kortelės gr.</Th>}
                      <Th>Duru ID</Th>
                      <Th>Kryptis</Th>
                      <Th>Data ir laikas</Th>
                      <Th textAlign={'center'}>Veiksmas</Th>
                    </Tr>
                  </Thead>

                  <Tbody>
                    {pickedUserLog.map((logRow, index) => {
                      const logRowAction = getDoorStatusBadge(logRow.action);
                      // jei ne emaitinimas sistema tada naudoti pname, psurname

                      if(!loadDataFromEmaitinimas){
                        logRow.name = logRow.pname;
                        logRow.surname = logRow.psurname;
                      }

                      return (

                        <Tr key={index} backgroundColor={clickedLogBox === logRow.id ? 'green.400' : ''} color={clickedLogBox === logRow.id ? 'white' : ''}>
                          <Td>{logRow.id}</Td>
                          <Td>{logRow.name !== null && `${logRow.name} ${logRow.surname}`}</Td>
                          <Td>{logRow.card_no}</Td>
                          {!loadDataFromEmaitinimas && <Td>{logRow.groupname}</Td>}
                          <Td>{logRow.door_id === 0 ? 'Visos' : logRow.door_id}</Td>
                          <Td>{logRow.direction === 'OUTSIDE' ? 'Išorinės' : logRow.direction === 'INSIDE' ? 'Vidinės' : logRow.direction}</Td>
                          <Td>{new Date(logRow.date).toLocaleString('lt-LT')}</Td>
                          <Td>{<Tag size={'sm'} variant='solid' colorScheme={clickedLogBox === logRow.id ? '' : logRowAction.color} >
                            <TagLeftIcon as={logRowAction.icon} />
                            <TagLabel>{logRowAction.text}</TagLabel>
                          </Tag>}</Td>
                        </Tr>

                      )
                    })
                    }
                  </Tbody>
                </Table>
              </TableContainer>
            }




          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default AccessLogCard